<template lang="html">
    <div class="article">
        <div class="banner-img">
        </div>
        <div class="container">
            <p>全医佳新闻资讯列表 / <span>内容详情</span></p>
            <div class="content">
                <h2>全医佳与彩超服务联盟缔结战略合作 共同打造医疗设备售后服务平台</h2>
                <p>2017年1月9日江苏全医佳电子商务有限公司携手“彩超技术服务联盟”，在南京紫东国际创意园正式签约，双方成立全医佳彩超合作联盟，有效实现资源信息互补、共享，提高双方的市场竞争力。出席本次活动的有软银赛富投资合伙人及全医佳平台董事长叶军、副总谢玉丹、副总裁徐凯、客户服务中心经理金平，以及彩超技术服务联盟会长张鹏、荣誉会长颜健鸿、联盟成员璟堃（上海）医疗科技有限公司、深圳市必利胜电子有限公司、北京顺昌鑫和科贸有限公司、迈迪泰医疗技术服务（上海）有限公司、西安迈晟电子科技有限公司、杭州君维科技有限公司、杭州中厚科技有限公司等。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/1-1.jpg" alt="">
                </div>
                <p>全医佳一站式医疗设备服务平台是中国为完善医疗设备服务市场而搭建的综合性纯服务类电商平台。公司核心团队曾成功运营一家医疗设备服务管理上市公司，具备雄厚的行业背景，拥有医疗设备服务业界完整的、端到端的云媒体资讯信息和高效服务体系。平台创新利用互联网开拓信息渠道，颠覆传统的服务运营模式。借助自主研发的“全医佳医院设备管理软件”和“全医佳云服务平台”为载体，通过整合医院、经销商、供应商等终端的产品和专业性服务，形成长期战略合作关系，共同建立了一个联盟性的行业生态链。真正实现海量行业信息资源的高效整合，灵活满足不同客的户差异化需求并实现集约化效益。公司自成立以来，平台运营与业务表现增长强劲，在医疗设备售后服务领域显示出强大的发展潜力，目前已成功获得preA轮融资，公司估值4亿人民币。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/1-2.jpg" alt="">
                </div>
                <p>彩超技术服务联盟由全国数十家彩超专业售后服务公司组成，成员均为行业内资深工程师及行业精英，行业服经验15年以上，深谙彩超售后服务运作模式及行业现状。联盟从技术、配件、管理等方面为成员能提供全方位的运营管理服务及平台。此外，联盟利用自身积累的技术储备和行业资源在全国范围内已成功举办大型专业培训多次，极大推广了业内技术交流，为打造积极健康的行业生态圈奠定了良好的基础。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/1-3.jpg" alt="">
                </div>
                <p>此次双方重拳出击，打造彩超领域国内医疗售后行业全国性联盟，联盟将发挥双方优势，真正实现海量行业资源的完美整合，建立完善技术、配件、工程师交流和流通平台。全医佳彩超合作联盟成员目前已覆盖十多个省市，全职彩超工程师约200名，配件库储备近亿。至此，全医佳彩超合作联盟已覆盖全品牌全系列所有型号超声设备，累计维修超声设备10万余台次，已为全国一万多家医院倾心服务。</p>
                <div>
                    <img src="https://static.qyjmed.com/webSite/news/company/1-4.jpg" alt="">
                </div>
                <p>相信全医佳彩超合作联盟定能以高效、优质的服务，为更多医院带去全面、快速、经济、专业、安全、周到的6S级设备管理体验。</p>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
export default {
    name:'article1',
    components: {
        Foot
    }
}
</script>

<style lang="scss" scoped>
    .article{
        letter-spacing: 1px;
        background: #F6F8FA;
        color: #000;
        .banner-img{
            margin-top: $highlight-height;
            height: 140px;
            background: url("https://static.qyjmed.com/webSite/productService/document/bg.png") center;
        }
        .container{
            >p{
                font-size: 18px;
                line-height: 76px;
                span{
                    color: #4EAAFC;
                }
            }
            .content{
                min-height: 600px;
                background: white;
                padding: 0 70px 70px;
                margin-bottom: 30px;
                h2{
                    font-size: 22px;
                    text-align: center;
                    font-weight: 400;
                    padding:46px 0 20px;
                }
                p{
                    line-height: 40px;
                    text-indent: 2rem;
                }
                div{
                    text-align: center;
                    img{
                        width: 900px;
                        padding:10px 0;
                    }
                }
            }
        }
    }
</style>
